import CustomAxios from "..";
export const uploadRecipeData = async (formData, fileName) => {
  try {
    const response = await CustomAxios.post(
      `/recipe/json?fileName=${encodeURIComponent(fileName)}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
}; 

export const updateStatusRecipeData = async (id) => {
  try {
    const response = await CustomAxios.patch(
      `/recipe/update-status/${id}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
}; 


export const deleteRecipeDataById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/recipe/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};


export const getRecipeDataById = async (id) => {
  try {
    const response = await CustomAxios.get(`/recipe/${id}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

export const getAllRecipeData = async (params) => {
  try {
    const response = await CustomAxios.get("/recipe",{params});
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getRecipeByTag = async (planTag) => {
  try {
    const response = await CustomAxios.get(`/recipe/search/category`, {
      params: {
        category: planTag,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching plans with tag "${planTag}":`,
      error.response?.data || error.message
    );
    throw new Error("Failed to retrieve the plans by tag. Please try again.");
  }
};
